export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_14.40d610d7.jpg";